<template>
  <section id="cashdesk" class="cashdesk">
    <div>
      <transition name="fade" mode="out-in" >
        <div class="section-top-row">
          <div class="row row-narrow align-items-center no-print position-relative">
            <div class="col order-md-0 order-0">
              <h1>{{ $t('fiscal_cashdesk') }}</h1>
            </div>
          </div>
        </div>
      </transition>
      <div class="sub-menu no-print">
        <template v-for="(m, mind) in menu">
          <router-link :to="{ name: m.to }"
                       v-if="!m.right || rights.includes(m.right)"
                       :key="`cashdesk-link-${mind}}`">
            {{ $t(m.title) }}
          </router-link>
        </template>
      </div>
    </div>
    <router-view v-if="loaded"
                 @update="update"
                 :vendor="vendor"/>
  </section>
</template>

<script setup>
import { useStore } from "vuex"
import { computed, onMounted, ref } from "vue"

const checkboxMenu = [
  { to: 'CashdeskSettings', title: 'settings', right: 'ppo' },
  { to: 'CashdeskCheques', title: 'cheques', right: 'ppo' },
  { to: 'CashdeskXReports', title: 'xreports', right: 'ppo' },
  { to: 'CashdeskShifts', title: 'shifts', right: 'ppo' },
]
const webkassaMenu = [
  { to: 'CashdeskSettings', title: 'settings', right: 'webkassa' },
  { to: 'CashdeskCheques', title: 'cheques', right: 'webkassa' },
  { to: 'CashdeskXReports', title: 'xreports', right: 'webkassa' },
  { to: 'CashdeskShifts', title: 'shifts', right: 'webkassa' },
]
const aqsiMenu = [
  { to: 'CashdeskSettings', title: 'settings', right: 'aqsi' },
  { to: 'CashdeskCheques', title: 'cheques', right: 'aqsi' },
  { to: 'CashdeskShifts', title: 'shifts', right: 'aqsi' },
]
const kkmMenu = [
  { to: 'CashdeskSettings', title: 'settings', right: 'kkm' },
  // { to: 'CashdeskCheques', title: 'cheques', right: 'kkm' },
  { to: 'CashdeskKKMShifts', title: 'shifts', right: 'kkm' },
  { to: 'CashdeskKKMReports', title: 'reports', right: 'kkm' },
  { to: 'CashdeskKKMOperations', title: 'warehouseoperation', right: 'kkm' },
  { to: 'CashdeskKKMTerminal', title: 'terminal', right: 'kkm' },
]
const newcasMenu = [
  { to: 'CashdeskSettings', title: 'settings', right: 'newcas' },
  { to: 'CashdeskShifts', title: 'shifts', right: 'newcas' },
  // { to: 'CashdeskKKMReports', title: 'reports', right: 'newcas' },
  { to: 'CashdeskKKMOperations', title: 'warehouseoperation', right: 'newcas' },
  { to: 'CashdeskKKMTerminal', title: 'terminal', right: 'newcas' },
]

const loaded = ref(false)

const store = useStore()

const rights = computed(() => store.state.auth.rights)
const ppoData = computed(() => store.state.ppo.ppoData)
const vendor = computed(() => ppoData.value.vendor || null)
const menu = computed(() => {
  if (vendor.value === 'webkassa') return webkassaMenu
  if (vendor.value === 'aqsi') return aqsiMenu
  if (vendor.value === 'kkm') return kkmMenu
  if (vendor.value === 'newcas') return newcasMenu
  if (vendor.value === 'checkbox') return checkboxMenu
  return checkboxMenu
})

const update = () => {
  store.dispatch('init')
  store.dispatch('getCashdeskData')
}

onMounted(async () => {
  await store.dispatch('getCashdeskData')
  loaded.value = true
})
</script>
